export class LoadImage {
  static readonly type = '[Image] Load image';
  constructor(public imageId: number) {}
}

export class LoadRelatedImages {
  static readonly type = '[Image] Load related images';
  constructor(public imageId?: number) {}
}

export class AddToFavorites {
  static readonly type = '[Image] Add to favorites';
  constructor(public imageId: number) {}
}

export class RemoveFromFavorites {
  static readonly type = '[Image] remove from favorites';
  constructor(public imageId: number) {}
}
